import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// --- SEO Meta Tags (lightweight, non-blocking) ---
document.documentElement.lang = 'es';
document.title = 'Método Elite AT — Sistema 360 de Gestión Clínica para Acompañantes Terapéuticos';
const metaDesc = document.createElement('meta');
metaDesc.name = 'description';
metaDesc.content = 'El sistema completo de gestión clínica para Acompañantes Terapéuticos. 8 módulos + bonos para cobrar a término, hacer informes impecables y trabajar con seguridad profesional.';
document.head.appendChild(metaDesc);
if (!document.querySelector('meta[name="viewport"]')) {
  const viewport = document.createElement('meta');
  viewport.name = 'viewport';
  viewport.content = 'width=device-width, initial-scale=1';
  document.head.appendChild(viewport);
}
if (!document.querySelector('meta[charset]')) {
  const charset = document.createElement('meta');
  charset.setAttribute('charset', 'UTF-8');
  document.head.prepend(charset);
}
const ogTags: Record<string, string> = {
  'og:title': 'Método Elite AT — Sistema 360 de Gestión Clínica',
  'og:description': 'El sistema completo para Acompañantes Terapéuticos. Cobrá a término, hacé informes impecables y trabajá con seguridad profesional.',
  'og:type': 'website',
  'og:image': 'https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg'
};
Object.entries(ogTags).forEach(([property, content]) => {
  const tag = document.createElement('meta');
  tag.setAttribute('property', property);
  tag.content = content;
  document.head.appendChild(tag);
});
const robots = document.createElement('meta');
robots.name = 'robots';
robots.content = 'index, follow';
document.head.appendChild(robots);
// Preconnect for hero image CDN (saves DNS+TLS ~100-200ms)
const preconnectCDN = document.createElement('link');
preconnectCDN.rel = 'preconnect';
preconnectCDN.href = 'https://cdn.magicpatterns.com';
preconnectCDN.crossOrigin = 'anonymous';
document.head.prepend(preconnectCDN);
// Preload hero image (LCP element)
const preloadHero = document.createElement('link');
preloadHero.rel = 'preload';
preloadHero.as = 'image';
preloadHero.href = 'https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg';
document.head.appendChild(preloadHero);
// Structured data
const jsonLd = document.createElement('script');
jsonLd.type = 'application/ld+json';
jsonLd.textContent = JSON.stringify({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: 'Método Elite AT — Sistema 360 de Gestión Clínica',
  description: 'El sistema completo de gestión clínica para Acompañantes Terapéuticos.',
  image: 'https://cdn.magicpatterns.com/uploads/aCfGkCexWC1BaDE3nrpJV5/formato_1_a_1.jpg',
  offers: [{
    '@type': 'Offer',
    name: 'Pack Base AT',
    price: '19990',
    priceCurrency: 'ARS',
    availability: 'https://schema.org/InStock',
    url: 'https://fegion.shop/cart/46280111620235:1'
  }, {
    '@type': 'Offer',
    name: 'Combo Élite AT',
    price: '29990',
    priceCurrency: 'ARS',
    availability: 'https://schema.org/InStock',
    url: 'https://fegion.shop/cart/46280115159179:1'
  }]
});
document.head.appendChild(jsonLd);
// --- End SEO ---
// --- RENDER FIRST, then load non-critical resources ---
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
render(<App data-id="element-377" />, document.getElementById('root'));
// === AFTER RENDER: Load Google Fonts (non-blocking, deferred) ===
// Using requestAnimationFrame ensures fonts load AFTER first paint
requestAnimationFrame(() => {
  // Preconnect
  const pc1 = document.createElement('link');
  pc1.rel = 'preconnect';
  pc1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(pc1);
  const pc2 = document.createElement('link');
  pc2.rel = 'preconnect';
  pc2.href = 'https://fonts.gstatic.com';
  pc2.crossOrigin = 'anonymous';
  document.head.appendChild(pc2);
  // Load fonts — only weights actually used, trimmed for speed
  const fontsLink = document.createElement('link');
  fontsLink.rel = 'stylesheet';
  fontsLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap';
  fontsLink.media = 'print';
  fontsLink.onload = function () {
    ;
    (this as HTMLLinkElement).media = 'all';
  };
  document.head.appendChild(fontsLink);
});
// === AFTER RENDER: Load Meta Pixel (deferred to not block critical resources) ===
// Using setTimeout(0) pushes pixel loading after initial render + paint
setTimeout(() => {
  const f = window as any;
  if (f.fbq) return;
  const n: any = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script') as HTMLScriptElement;
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  const s = document.getElementsByTagName('script')[0];
  s?.parentNode?.insertBefore(t, s);
  f.fbq('init', '904978025482552');
  f.fbq('track', 'PageView');
  // noscript fallback
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = 'https://www.facebook.com/tr?id=904978025482552&ev=PageView&noscript=1';
  document.body.appendChild(img);
}, 0);